import { TaskPriority, TaskStatus } from '@gql/graphql';

export const TASK_STATUS_SORT_MAP = {
    [TaskStatus.Notstarted]: 1,
    [TaskStatus.Inprogress]: 2,
    [TaskStatus.Onhold]: 3,
    [TaskStatus.Completed]: 4,
    [TaskStatus.Aborted]: 5,
};

export const TASK_PRIORITY_SORT_MAP = {
    [TaskPriority.P01Veryhigh]: 1,
    [TaskPriority.P02High]: 2,
    [TaskPriority.P03Medium]: 3,
    [TaskPriority.P04Low]: 4,
};

export const RATING_SORT_MAP = {
    LOW: 1,
    MEDIUM: 2,
    HIGH: 3,
    VERYHIGH: 4,
};

const mapComparator =
    <T, Key extends keyof T>(map: T) =>
    (valueA?: Key, valueB?: Key) => {
        const numberRatingA = valueA && map[valueA] ? map[valueA] : 0;
        const numberRatingB = valueB && map[valueB] ? map[valueB] : 0;
        if (numberRatingA === numberRatingB) return 0;
        return numberRatingA > numberRatingB ? 1 : -1;
    };

export default mapComparator;
